import { render, staticRenderFns } from "./DirectiveHelpSection.vue?vue&type=template&id=44fdc760"
import script from "./DirectiveHelpSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectiveHelpSection.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports